import axiosInstance from "./axiosInstance";

export const filtrarTitulares = async (adminId, search) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/filtrarTitular-v2?adminId=${adminId}&search=${search}`
  );
};
